import React, { useEffect, useState } from "react";
import { Table, Button, Container, Form, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

/*------------- Page Imports -------------------- */

import SideMenu from "../../../Components/SideDrawer";
import PageHeader from "../../../Components/Header";
import { companyGet, employeeGet, truckTripPost } from "../../../Api/Admin/AdminApi";
import { extractErrorMessage } from "../../../Utils/ErrorUtlis";

const TruckTrip = () => {
  const [organizations, setOrganizations] = useState([]);
  const [drivers, setDrivers] = useState([]);
  const [formData, setFormData] = useState({
    company_id: null,
    emp_id: '',
    trip_date: '',
    trip_cost: '',
    remarks: ''
  });
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const data = await companyGet();
        if (data) {
          const companies = data.map(i => ({
            id: i._id,
            name: i.name,
            description: i.description,
            status: i.status
          }));
          setOrganizations(companies)
        } else {
          console.log('No Organization data to fetch');
          alert('No data to Fetch');
        }

      } catch (err) {
        const errorMessage = extractErrorMessage(err)
        console.log('Error Fetching Data in Organization: ', errorMessage || err);
        alert(errorMessage)
      }
    }
    fetchCompany();
  }, []);

  const getDriver = async (id) => {
    try {
      const response = await employeeGet(id);
      if (response && response.result) {
        const driver = response.result.map(i => ({
          emp_id: i.emp_id,
          emp_name: i.emp_name,
          designation: i.designation
        })).filter(dri => dri.designation === 'DRIVER-4');
        setDrivers(driver);
        console.log('Driver Data: ', drivers);
      }
    } catch (err) {
      const errorMessage = extractErrorMessage(err)
      console.log('Error Fetching Data in Organization: ', errorMessage || err);
      alert(errorMessage)
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    if (name === 'company_id') {
      getDriver(value);
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await truckTripPost(JSON.stringify(formData));
      if (response) {
        alert("Truck trip Added Successfully...");
        navigate('/truckTrip')
      }
    } catch (err) {
      const errorMessage = extractErrorMessage(err)
      console.log('Error Fetching Data in Organization: ', errorMessage || err);
      alert(errorMessage)
    }
  };

  return (
    <div>
      <SideMenu />
      <Container fluid style={{
        marginLeft: '250px',
        padding: '20px',
        transition: 'margin 0.3s ease',
        width: 'calc(100% - 250px)'
      }}>
        <PageHeader
          title="Truck Trip Details"
          showButtons={true}
        />
        <Form onSubmit={handleSubmit} className="mt-4">
          <Row className="mb-3">
            <Form.Group as={Col} md="4" controlId="company_id">
              <Form.Label>Organization Name</Form.Label>
              <Form.Select
                name="company_id"
                value={formData.organizationName}
                onChange={handleChange}
                required
              >
                <option value="">Select Organization</option>
                {organizations.map(org => (
                  <option key={org.id} value={org.id}>{org.name}</option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group as={Col} md="4" controlId="emp_id">
              <Form.Label>Driver Name</Form.Label>
              <Form.Select
                name="emp_id"
                value={formData.emp_id}
                onChange={handleChange}
                required
              >
                <option value="">Select Driver</option>
                {drivers.map(driver => (
                  <option key={driver.emp_id} value={driver.emp_id}>{driver.emp_name}</option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group as={Col} md="4" controlId="trip_date">
              <Form.Label>Trip Date</Form.Label>
              <Form.Control
                type="date"
                name="trip_date"
                value={formData.trip_date}
                onChange={handleChange}
                required
              />
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col} md="6" controlId="trip_cost">
              <Form.Label>Trip Cost</Form.Label>
              <Form.Control
                type="number"
                name="trip_cost"
                value={formData.trip_cost}
                onChange={handleChange}
                placeholder="Enter trip cost"
                required
              />
            </Form.Group>

            <Form.Group as={Col} md="6" controlId="remarks">
              <Form.Label>Remarks</Form.Label>
              <Form.Control
                as="textarea"
                rows={1}
                name="remarks"
                value={formData.remarks}
                onChange={handleChange}
                placeholder="Enter any remarks"
              />
            </Form.Group>
          </Row>

          <Form.Group as={Row} className="mb-4">
            <Col className='text-center'>
              <Button variant="primary" type="submit" className="mt-5">
                Submit
              </Button>
            </Col>
          </Form.Group>
        </Form>
      </Container>
    </div>
  )
};

export default TruckTrip;